import * as React from "react"
import { Text as BaseText, TextProps } from "gatsby-interface"

export function Text(props: TextProps) {
  return (
    <BaseText
      css={{
        marginBottom: 0,
      }}
      {...props}
    />
  )
}
